/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScreeningRecordRole } from './InternalApiScreeningRecordRole';
import {
    InternalApiScreeningRecordRoleFromJSON,
    InternalApiScreeningRecordRoleFromJSONTyped,
    InternalApiScreeningRecordRoleToJSON,
    InternalApiScreeningRecordRoleToJSONTyped,
} from './InternalApiScreeningRecordRole';
import type { InternalApiAssociationDetails } from './InternalApiAssociationDetails';
import {
    InternalApiAssociationDetailsFromJSON,
    InternalApiAssociationDetailsFromJSONTyped,
    InternalApiAssociationDetailsToJSON,
    InternalApiAssociationDetailsToJSONTyped,
} from './InternalApiAssociationDetails';

/**
 * 
 * @export
 * @interface InternalApiScreeningRecord
 */
export interface InternalApiScreeningRecord {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningRecord
     */
    externalId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningRecord
     */
    aliases?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningRecord
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningRecord
     */
    additionalInformation: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningRecord
     */
    recordDate: Date;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningRecord
     */
    notes?: string;
    /**
     * 
     * @type {Array<InternalApiScreeningRecordRole>}
     * @memberof InternalApiScreeningRecord
     */
    roles?: Array<InternalApiScreeningRecordRole>;
    /**
     * 
     * @type {Array<InternalApiAssociationDetails>}
     * @memberof InternalApiScreeningRecord
     */
    associations?: Array<InternalApiAssociationDetails>;
}

/**
 * Check if a given object implements the InternalApiScreeningRecord interface.
 */
export function instanceOfInternalApiScreeningRecord(value: object): value is InternalApiScreeningRecord {
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    if (!('additionalInformation' in value) || value['additionalInformation'] === undefined) return false;
    if (!('recordDate' in value) || value['recordDate'] === undefined) return false;
    return true;
}

export function InternalApiScreeningRecordFromJSON(json: any): InternalApiScreeningRecord {
    return InternalApiScreeningRecordFromJSONTyped(json, false);
}

export function InternalApiScreeningRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'externalId': json['externalId'],
        'aliases': json['aliases'] == null ? undefined : json['aliases'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'additionalInformation': json['additionalInformation'],
        'recordDate': (new Date(json['recordDate'])),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'roles': json['roles'] == null ? undefined : ((json['roles'] as Array<any>).map(InternalApiScreeningRecordRoleFromJSON)),
        'associations': json['associations'] == null ? undefined : ((json['associations'] as Array<any>).map(InternalApiAssociationDetailsFromJSON)),
    };
}

export function InternalApiScreeningRecordToJSON(json: any): InternalApiScreeningRecord {
    return InternalApiScreeningRecordToJSONTyped(json, false);
}

export function InternalApiScreeningRecordToJSONTyped(value?: InternalApiScreeningRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalId': value['externalId'],
        'aliases': value['aliases'],
        'summary': value['summary'],
        'additionalInformation': value['additionalInformation'],
        'recordDate': value['recordDate'].toISOString(),
        'notes': value['notes'],
        'roles': value['roles'] == null ? undefined : ((value['roles'] as Array<any>).map(InternalApiScreeningRecordRoleToJSON)),
        'associations': value['associations'] == null ? undefined : ((value['associations'] as Array<any>).map(InternalApiAssociationDetailsToJSON)),
    };
}

